import { useState } from 'react';
import { GalleryWidgetModel } from '../../../models/GalleryWidgetModel';
interface useGalleryRenderingProps {
  formData: GalleryWidgetModel;
}
// Fullscreen képek megjelenítése
const useGalleryRendering = ({ formData }: useGalleryRenderingProps) => {
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [viewerImageIndex, setViewerImageIndex] = useState<null | number>(null);

  // Megfelelő indexxel megnyitja a fullscreen galériát
  const openImageViewer = (imageIndex: number) => {
    setViewerImageIndex(imageIndex);
    setViewerOpen(true);
  };
  // fullscreen galéria bezárása
  const closeImageViewer = () => {
    setViewerOpen(false);
  };
  const showPreviousImage = () => {
    // ha az imageindex nem null
    if (viewerImageIndex !== null) {
      // felveszi a mostani index előtti értéket
      let prevIndex = viewerImageIndex - 1;
      // amíg ez az index nagyobb mint 0, valamint van megadva kép, tovább csökkenti az indexet egyel
      while (prevIndex > 0 && formData.images[prevIndex].fileName === '') {
        prevIndex--;
      }
      // ha az első képnél vagyunk akkor az utolsó képre állítja
      if (prevIndex < 0) prevIndex = formData.images.length - 2;
      // megjeleníti a képet a megfelelő indexxel
      setViewerImageIndex(prevIndex);
    }
  };

  const showNextImage = () => {
    // ha az imageindex nem null
    if (viewerImageIndex !== null) {
      // felveszi a mostani index utáni értéket
      let nextIndex = viewerImageIndex + 1;
      // amíg ez az index kisebb mint a képek száma, valamint van megadva kép, tovább növeli az indexet egyel
      while (nextIndex < formData.images.length && formData.images[nextIndex].fileName === '') {
        nextIndex++;
      }
      // az utolsó képnél az első képre állítja
      if (nextIndex === formData.images.length - 1) nextIndex = 0;
      // megjeleníti a képet a megfelelő indexxel
      setViewerImageIndex(nextIndex);
    }
  };

  return { isViewerOpen, closeImageViewer, openImageViewer, showPreviousImage, showNextImage, viewerImageIndex };
};

export default useGalleryRendering;
